<template>
    <path fill-rule="evenodd" d="M16 .64C24.483.64 31.36 7.517 31.36 16S24.483 31.36 16 31.36.64 24.483.64 16 7.517.64 16 .64zm0 3.413C9.402 4.053 4.053 9.402 4.053 16c0 6.598 5.349 11.947 11.947 11.947 6.598 0 11.947-5.349 11.947-11.947 0-6.598-5.349-11.947-11.947-11.947zm0 3.414c4.713 0 8.533 3.82 8.533 8.533 0 4.713-3.82 8.533-8.533 8.533-4.713 0-8.533-3.82-8.533-8.533 0-4.713 3.82-8.533 8.533-8.533z"/>
</template>

<script>
export default {
    name: 'statusDotsIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
